var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExamIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 100,
    viewBox: "0 0 84 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.0083 8.33333C56.325 8.33333 50 33.3333 50 33.3333C50 33.3333 75 26.4583 75 43.5708V91.6667H8.33333V8.33333H39.0083ZM42.4542 0H0V100H83.3333V40.0583C83.3333 30.0958 55.6333 0 42.4542 0ZM62.5 54.1667H20.8333V50H62.5V54.1667ZM62.5 62.5H20.8333V66.6667H62.5V62.5ZM62.5 75H20.8333V79.1667H62.5V75Z",
    fill: "#EBF2FA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExamIcon);
export default __webpack_public_path__ + "static/media/Exam_Icon.ed987f6e8f9c2a936e7f40dea30e8528.svg";
export { ForwardRef as ReactComponent };